<template lang="html">
<div>

<Vizsgak v-show="Vizsgak_show"></Vizsgak>

<VizsgaDetails v-show="VizsgaDetails_show"></VizsgaDetails>

<v-btn
  v-if="user_mail != 'vizsga@csigaver.hu'"
  v-show="Vizsgak_show"
  @click="newExam"
  fixed
  dark
  fab
  bottom
  left
  color="white"
>
<img src="https://www.gstatic.com/images/icons/material/colored_icons/1x/create_32dp.png">
</v-btn>

<v-btn
  v-show="VizsgaDetails_show"
  @click="BackExam"
  fixed
  dark
  fab
  bottom
  right
  color="red"
>
<v-icon>undo</v-icon>
</v-btn>

</div>
</template>

<script>
import VizsgaDetails from '../components/vizsga_details.vue'
import Vizsgak from '../components/vizsgak.vue'
import store from '../store'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    VizsgaDetails,
    Vizsgak
  },
  data () {
    return {
    }
  },
  methods: {
    BackExam: function () {
      this.VizsgaDetails_show = false,
      this.Vizsgak_show = true
      this.exam_id = null
    },
    newExam() {
      this.$eventBus.$emit('newExam')
    },
  },
  mounted () {

  },
  computed: {
  ...mapFields([
  'auth.user_mail',
  'showing.VizsgaDetails_show',
  'showing.Vizsgak_show',
  'exam_details.exam_gui_id',
  'exam_details.exam_date',
  'exam_details.exam_time',
  'exam_details.school_select',
  'exam_details.exam_location',
  'exam_details.exam_id',
]),
},

}

</script>

<style>
</style>
